import React, { useMemo } from 'react';
import Select from 'react-select';
import styles from './SearchableSelect.module.css';

const SearchableSelect = ({
  options = [],
  value = '',
  onChange,
  placeholder = 'Выберите значение',
  ariaLabel,
  isLoading = false,
  isDisabled = false,
  isMulti = false,
  className = '',
}) => {
  const selectedOption = useMemo(
    () => isMulti
      ? options.filter((option) => (value || []).some((item) => String(item) === String(option.value)))
      : options.find((option) => String(option.value) === String(value)) || null,
    [options, value, isMulti],
  );

  return (
    <Select
      className={`${styles.select} ${className}`.trim()}
      classNamePrefix="searchable-select"
      options={options}
      value={selectedOption}
      onChange={(option) => onChange?.(isMulti
        ? (option || []).map((item) => item.value)
        : option?.value ?? '')}
      placeholder={placeholder}
      aria-label={ariaLabel || placeholder}
      isSearchable
      isLoading={isLoading}
      isDisabled={isDisabled}
      isMulti={isMulti}
      menuPlacement="auto"
      menuPosition="fixed"
      menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
      openMenuOnFocus
      captureMenuScroll={false}
      noOptionsMessage={({ inputValue }) => (
        inputValue ? `Ничего не найдено по запросу «${inputValue}»` : 'Нет доступных значений'
      )}
      loadingMessage={() => 'Загрузка…'}
      screenReaderStatus={({ count }) => `Найдено вариантов: ${count}`}
      styles={{ menuPortal: (base) => ({ ...base, zIndex: 3000 }) }}
    />
  );
};

export default SearchableSelect;
